$(document).ready(function(){

//   $('.description_tab_title2').click(function(){
//      $('.description_tab_title2').removeClass('active');
//     $(this).addClass('active');
//     // $('.description_tab_title2').not($(this)).removeClass('active');
//     // $('.main_description_container2').not($(this).parents('.product-faq').find('.main_description_container2')).slideUp();
//     // $(this).parents('.product-faq').find('.main_description_container2').slideToggle();
// })

   $(document).on("click","img.icon.icon-close",function() {  
    $('.menu-drawer-container').removeAttr('open');
    $('.header__icon--menu').attr('aria-expanded',false);
    $('body').removeClass('overflow-hidden-tablet');
});

  
  $('.contact-query').click(function() {
    $(".contact-us-query-popup").fadeOut();
    var popupId = $(this).data('popup');
    $('#' + popupId).fadeIn();
    $("body").addClass("enable_contact_popup");
  });

  $('.contact-us-query-popup').click(function(event) {
    if ($(event.target).is('.contact-us-query-popup')) {
      $(this).fadeOut();
       $("body").removeClass("enable_contact_popup");
    }
  });

  $('.close-popup').click(function() {
    $(this).closest('.contact-us-query-popup').fadeOut();
     $("body").removeClass("enable_contact_popup");
  });






  
var banners = document.querySelectorAll('.banner-collection-sec');
    banners.forEach(function (banner) {
        if (banner.innerHTML.trim() === '') {
            banner.style.display = 'none';
        }
    });

  
         setTimeout(function(){
  var fullText = $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').text();
    var splitText = fullText.split('(');
    if (splitText.length > 1) {
        var beforeText = splitText[0];
        var afterText = '(' + splitText[1]; 
        var newText = beforeText + `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.357 7.12611C16.1344 6.90171 16.009 6.59881 16.0078 6.28277V5.21777C16.0069 4.57033 15.7493 3.94967 15.2914 3.49193C14.8335 3.0342 14.2128 2.77677 13.5653 2.7761H12.502C12.3454 2.77652 12.1903 2.74595 12.0455 2.68617C11.9008 2.62639 11.7693 2.53857 11.6587 2.42777L10.7503 1.5186C10.292 1.06143 9.67103 0.804688 9.02366 0.804688C8.37629 0.804688 7.75534 1.06143 7.29699 1.5186L6.38866 2.42777C6.27807 2.53872 6.14662 2.62669 6.00188 2.68662C5.85714 2.74654 5.70198 2.77724 5.54532 2.77694H4.48116C3.83371 2.7776 3.21296 3.03503 2.75507 3.49277C2.29718 3.9505 2.03954 4.57116 2.03866 5.2186V6.28277C2.03781 6.59848 1.91267 6.90115 1.69032 7.12527L0.780324 8.03444C0.323147 8.49278 0.0664063 9.11373 0.0664062 9.76111C0.0664062 10.4085 0.323147 11.0294 0.780324 11.4878L1.69032 12.3961C1.91287 12.6205 2.03828 12.9234 2.03949 13.2394V14.3044C2.04037 14.9519 2.29802 15.5725 2.75591 16.0303C3.2138 16.488 3.83455 16.7454 4.48199 16.7461H5.54532C5.70198 16.7458 5.85714 16.7765 6.00188 16.8364C6.14662 16.8964 6.27807 16.9843 6.38866 17.0953L7.29699 18.0044C7.75523 18.4618 8.37622 18.7187 9.02366 18.7187C9.6711 18.7187 10.2921 18.4618 10.7503 18.0044L11.6587 17.0953C11.7692 16.9843 11.9007 16.8964 12.0454 16.8364C12.1902 16.7765 12.3453 16.7458 12.502 16.7461H13.5662C14.2136 16.7454 14.8344 16.488 15.2922 16.0303C15.7501 15.5725 16.0078 14.9519 16.0087 14.3044V13.2394C16.0094 12.9235 16.1349 12.6207 16.3578 12.3969L17.267 11.4878C17.7242 11.0294 17.9809 10.4085 17.9809 9.76111C17.9809 9.11373 17.7242 8.49278 17.267 8.03444L16.357 7.12611Z" fill="#2196F3"></path>
<path d="M7.92726 12.7688C7.81943 12.7691 7.71262 12.7479 7.61303 12.7066C7.51344 12.6652 7.42305 12.6045 7.34711 12.528L5.15784 10.3387C5.01282 10.1831 4.93388 9.97724 4.93763 9.76455C4.94138 9.55187 5.02754 9.34894 5.17796 9.19852C5.32838 9.0481 5.5313 8.96194 5.74399 8.95819C5.95668 8.95444 6.16252 9.03339 6.31815 9.1784L7.92726 10.7864L11.7256 6.98914C11.8813 6.84412 12.0871 6.76517 12.2998 6.76893C12.5125 6.77268 12.7154 6.85884 12.8658 7.00926C13.0162 7.15967 13.1024 7.3626 13.1062 7.57529C13.1099 7.78798 13.031 7.99382 12.8859 8.14945L8.50741 12.528C8.43147 12.6045 8.34108 12.6652 8.24149 12.7066C8.1419 12.7479 8.03509 12.7691 7.92726 12.7688Z" fill="white"></path>
</svg>` + afterText;
        $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').html(newText);
    }
         },550);

 let swiper = new Swiper('.how-to-use-product-listing', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3.4,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
        breakpoints: {
            1920: {
                slidesPerView: 3.4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            430: {
                slidesPerView:2.5,
                spaceBetween: 10
            }
        }
    });
    var initialTitle = $('.main_setps.active').data('title'); 
    $('.main-step-content-wrapper').each(function() {
        var contentTitle = $(this).data('title');
        if (contentTitle === initialTitle) {
            $(this).show(); 
        } else {
            $(this).hide();
        }
    });
  
    $('.main_setps').click(function() {
        var title = $(this).attr('data-title');
        $('.main_setps').removeClass('active');
        $(this).addClass('active');
        
        $('.main-step-content-wrapper').each(function() {
            var contentTitle = $(this).attr('data-title');
                          $(".main-step-content-wrapper").hide();
            if (contentTitle === title) {
                $(this).show();  
              swiper.destroy(true, true);
              swiper = new Swiper('.how-to-use-product-listing', {
              loop: true,
              slidesPerView: 3.5,
              spaceBetween: 30,
            });
              
            } 
        });
    });

    $('.main-step-content-wrapper').hide();
  if($(".main_setps .steps").hasClass("active")){
    $('.steps.active').each(function() {
        $(this).closest('.main_setps').trigger('click');
    });
  }else{
     $('.main-step-content-wrapper').first().show();
  }
    



  
 $('.subscription_custom_wrap .input-wrapper').click(function(){
    $('.input-wrapper').removeClass('checked')
    $(this).addClass('checked')
});


 $(document).on("click",".bottom-text-wraper",function() {
    $(".more-info-data-container").slideToggle();
       $(this).toggleClass('active');
  });

  var tag_fre_pro_attr= $('body').attr('free_pro_attr');
              var tag_fre_pro_id= $('body').attr('free-pro-data-attr');
             if(tag_fre_pro_attr == 'false'){
              $.ajax({
                          url: "/cart",
                          type: "GET",
                          dataType: "html",
                          success: function (t) {
                            $("cart-drawer-items").html($(t).find("cart-drawer-items").html());
                              $(".cart-item").each(function () {
                                var itemId = $(this).attr("item_id"); 
                             var fre_pro_line_item_attr = $(this).attr('fre_pro_attr');
                               if(fre_pro_line_item_attr){
                                  var deleted_pro_id = $(this).attr("item_id");
                                  jQuery.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                 async : false,
                                data: { quantity: 0,id: deleted_pro_id},
                                dataType: 'json',
                                  success: function (data) { 
                                  $.ajax({
                                   url: '/cart',
                                   type: "GET",
                                   dataType: "html",
                                       success: function(data) {
                                          $("#CartDrawer").html($(data).find('#CartDrawer').html());
                                            var productLenght = $('tr.cart-item').length;
                                           if(productLenght==0){
                                           $('cart-drawer.drawer').addClass('is-empty');
                                             $('#main-cart-footer').addClass('is-empty');
                                          $('cart-items.gradient').addClass('is-empty');
                                          }   
                                       $('.cart-count-bubble').html($(data).find('#CartDrawer .cart-item').length);
                                         $('.cart-count-bubble').html($(data).find('.cart-count-bubble').html());
                                          $('.cart__items').html($(data).find('.cart__items').html());
                                       },
                                    });
                                  }
                               })
                                }
                             });
          },
                      });
              }
                

$(document).on('click','.st-search-icon',function(){
$('.st-mobile-searchbox ').attr('style','display: block !important')
});
  $(document).on('click','.copied_content',function(){
     $('.copied').text('Copy Code');
$(this).parents('.coupon_code_list').find('.copied').text('Copied!');
  
});
   $(document).on("click",".collection ul.tabs li",function() {
       var Collectionlink = $(this).attr('collection-url');
      $(this).parents('.collection').find('a.link.underlined-link').attr('href',Collectionlink);
		var tab_id = $(this).attr('data-tab'); 
		$(this).parents('.collection').find('ul.tabs li').removeClass('current');
		$(this).parents('.collection').find('.tab-content').removeClass('current');
        $(this).parents('.collection').find('.tab-content').css('opacity','0');
         $(this).parents('.collection').find('.tab-content').fadeOut('slow');
        setTimeout(function(){
          window.dispatchEvent(new Event('resize'));
          $("#"+tab_id).fadeIn('slow');
           $("#"+tab_id).css('opacity','1');        
        },50);
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');    
	}); 
   $(document).on("click",".testimoniols-tab-link",function() {
    $('.custom-collection-tab').css('opacity','1')
    setTimeout(function(){window.dispatchEvent(new Event('resize'));},100)  
		var testimonials_tab_id = $(this).attr('testimonials-data-tab');
		$('.testimoniols-tab-link').removeClass('testimonials-current');
		$('.testimonials-current').removeClass('testimonials-current');
		$(this).addClass('testimonials-current');
		$("#"+testimonials_tab_id).addClass('testimonials-current');
	});
  var Swipes1 = new Swiper('.collection-swiper-container', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            480: {
                slidesPerView:'auto',
                spaceBetween: 10
            }
        }
    });
setTimeout(function(){$('body .custom-collection-tab').css('opacity','1')},700)
 var swiper2 = new Swiper('.swiper-container', {  
    pagination: {
         nextEl: '.testimonials-swiper-button-nextt',
         prevEl: '.testimonials-swiper-button-prevv',
       },
    pagination: '.swiper-pagination1, .swiper-pagination2',
      paginationClickable: true,
  });

if (window.matchMedia("(max-width: 749px)").matches){
    var Swipesc = new Swiper('.mobile-swiper-container', {   
        loop: false,       
        slidesPerView: 'auto',
        spaceBetween: 20,
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true
        }
    });
     var SwipesP = new Swiper('.icon-text-swiper', {   
        loop: false,       
        slidesPerView: 'auto',
        spaceBetween: 20,
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true
        } 
    });
  
}
  $(document).on("click",".read_more",function() { 
    $('.half_content').hide();
    $('.full_content').show();
  });
    $(document).on("click",".read_less",function() { 
    $('.half_content').show();
    $('.full_content').hide();
  });


  

  $(document).on("click","h2.footer-block__heading.inline-richtext",function() {
    $(this).next().toggleClass("active");
    $(this).toggleClass("active");
  });
  $(document).mouseup(function (e) {
     var popup = $("ul.footer-block__details-content.list-unstyled");
     if (!$('h2.footer-block__heading.inline-richtext').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {       
       popup.removeClass('active');
       $('h2.footer-block__heading.inline-richtext').removeClass('active');
        
     }
 });
  
 if (window.matchMedia("(max-width: 989px)").matches){ 
   
var heights = $(".collection-swiper-container ul").map(function ()
    {
        return $(this).height();
    }).get();

   
maxHeight = Math.max.apply(null, heights);
$('.collection-swiper-container ul li').css('height' , maxHeight);
  
  // $(document).on("click","a.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
  //   // $('.st-autocomplete-box-container').toggle();
  //   $('.st-autocomplete-box-container').show();
  // });

    $(document).on("click","span.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
     $('.st-autocomplete-box-container').toggle();
     $('body').toggleClass('st-no-scroll');
  });


   $(document).mouseup(function (e) {
     var popup = $(".st-autocomplete-box-container");
     if (!$('input#st-mobile-autocomplete-search-bar').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0 && !$('.st-searchicon').is(e.target)) {     
       popup.hide();
        $('body').removeClass('st-no-scroll');
       
     }
 });


 
   
 }

  
});

function copyToClipboard(element) {  
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();  
}





/*** Share button click Event ***/
$('#share-toggle-button').click(function(){
 if (navigator.share && $(window).width() <1067) {
        navigator.share({
          title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
          url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
        });
      }else {
   if ($(this).parents('.product-meta__share').find('.popover[open]').length >0) {
        $(this).parents('.product-meta__share').find('.popover').removeAttr('open',false);
    } else {
        $(this).parents('.product-meta__share').find('.popover').attr('open',true);
    }
 }
});
 $('.popover__close-button').click(function(){
 $(this).parents('.popover').attr('open',false);
})
 
/*** Share button click Event END here***/
  /* hide popup outer from container */
   if($('body').hasClass('cstm-product') && $('.popover,.popover__header').length > 0){
   document.addEventListener('mouseup', function(e) {
    var container = $('.popover,.popover__header');
     console.log(e);
    if (!container.is(e.target) && !$(".close").is(e.target)) {
        var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
        $(container).attr('open',false)
    }
}); 
   }
  /* hide popup outer from container END*/



// Define the setCookie function globally
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

$(document).ready(function() {
    var modal = $("#myModal");
  var delay_range = parseInt(modal.attr('delay_range'));
  var delay_range_value = delay_range * 1000;
     var modalClosed = getCookie("modalClosed");
  var modalClosedd = getCookie("modalClosedd")
     if (!modalClosed && !modalClosedd && window.location.href.indexOf("challenge") <0) {
        setTimeout(function() {
        modal.css("display", "block");
        }, delay_range_value);
    }
  if(window.location.href.indexOf('form_type=customer') > -1 || window.location.href.indexOf('customer_posted=true') > -1){
    modal.css("display", "block");
    $('.newsletter-form__field-wrapper').hide();
        $('button#Subscribe').hide();
     $('.after_subscription_message').show();
      var after_sub_heading = $('.after_subscription_heading').text();
    var before_sub_heading =  $('#subs-heading').text(after_sub_heading);
    var after_sub_desc = $('.after_subscription_desc').text();
    var before_sub_desc =  $('#subs-desc').text(after_sub_desc);
   
  }
  function cookiesData(day_range,hours_range,range_type){
      if(range_type == 'days'){
          var totalMilliseconds = (day_range * 24 * 60 * 60 * 1000);
        } else{
          var totalMilliseconds = (hours_range * 60 * 60 * 1000);
        } 
        setCookie("modalClosed", true, totalMilliseconds); 
  }
$(".close").click(function() {
    var modal = $(this).closest('.modal'); 

    var day_range = parseInt(modal.attr('day_range')); 
    var hours_range = parseInt(modal.attr('hours_range')); 
    var range_type = modal.attr('data_range_type'); 
        modal.css("display", "none");
      cookiesData(day_range,hours_range,range_type);
     var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
});
$(window).click(function(event) {
    var modal =$('#myModal');
       var day_range = parseInt(modal.attr('day_range'));
      var hours_range = parseInt(modal.attr('hours_range'));
     var range_type = modal.attr('data_range_type'); 
        if ($(event.target).is("#myModal")) {
            modal.css("display", "none");
           cookiesData(day_range,hours_range,range_type);
        }
    });

function setCookie(name, value, milliseconds) {
    var expires = "";
    if (milliseconds) {
        var date = new Date();
        date.setTime(date.getTime() + milliseconds);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

    
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});


$(document).ready(function() {
    if (window.location.href.indexOf("challenge") > -1) {
        $("#myModal").css("display", "none");
    }
    // if (window.location.href.indexOf("?customer_posted=true") > -1) {
    //     $("#myModal").css("display", "none");
    //     setCookie("modalClosed", true, 1); // Set cookie for 1 day
    // }
});


$(document).ready(function() {
  var swiper = new Swiper(".new-swiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,  // Default state for the scrollbar
      draggable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.9,
        spaceBetween: 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
        },
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          draggable: true,
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
          draggable: true,
        },
      },
    },
  });

  $(window).resize(function() {
    var windowWidth = $(window).width();
    if (windowWidth >= 1024) {
      swiper.params.scrollbar.hide = true;  
    } else {
      swiper.params.scrollbar.hide = false; 
    }
    swiper.update(); 
  });
});


  // $(document).on("click", "h2.footer-block__heading.inline-richtext", function() {
  //   var $this = $(this);
  //   var $next = $this.next();
  //   if ($next.length) {
  //     $next.toggleClass("active");
  //   }
  //   $this.toggleClass("active");
  // });


















